import type { CardProps } from "@mui/joy";
import { Card } from "@mui/joy";
import { colorTokens } from "../../styles/globalStyles";

interface DarkCardProps extends CardProps {
  dense?: boolean;
}

export default function DarkCard({ dense = false, sx, children, ...props }: DarkCardProps) {
  const baseStyles = {
    background: `linear-gradient(135deg, ${colorTokens.bg.surface} 0%, ${colorTokens.bg.surfaceElevated} 100%)`,
    border: `1px solid ${colorTokens.border.default}`,
    borderRadius: "8px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.5)",
    padding: dense ? 1.5 : 2,
    ...sx,
  };

  return (
    <Card sx={baseStyles} {...props}>
      {children}
    </Card>
  );
}
